module.exports = "/fonts/vendor/line-awesome/dist/line-awesome/la-regular-400.woff?aa859c0d08b8193d6586665343356098";